// src/components/gavion/integrations/api/unavailableM365Api.ts
import { M365ApiError, type M365Api } from "./types";

const fail = async (): Promise<never> => {
  throw new M365ApiError("m365_unavailable");
};
/** Placeholder until Task 22: reads look "not connected", writes fail with m365_unavailable. */
export const unavailableM365Api = (): M365Api => ({
  microsoftStatus: async () => ({
    status: "none",
    scopes: [],
    missing: ["mail_sync", "send", "calendar", "teams_meetings", "archive"],
    externalEmail: null,
    lastSyncAt: null,
    lastError: null,
    adminConsentUrl: null,
  }),
  startMicrosoftConnect: fail,
  storeMicrosoftTokens: fail,
  disconnectMicrosoft: fail,
  teamsConfig: async () => ({
    teamId: null,
    teamName: null,
    channelId: null,
    channelName: null,
    posterSalesId: null,
    webhookConfigured: false,
  }),
  listTeams: async () => [],
  listChannels: async () => [],
  saveTeamsChannel: fail,
  setTeamsWebhook: fail,
  getSignature: async () => "",
  saveSignature: fail,
  sendEmail: fail,
  messageBody: fail,
  attachmentUrl: fail,
  storedMessage: async () => null, // GAVION full-email
  storedAttachmentUrl: fail,
  bookDemo: fail,
  rescheduleDemo: fail,
  cancelDemo: fail,
});
